const css = `.B1KR9G__rangesWithTime,.B1KR9G__ranges{grid-template-columns:1fr min-content 1fr;align-items:center;gap:16px 6px;display:grid}.B1KR9G__rangesWithTime{grid-template-columns:1.5fr 1fr min-content 1.5fr 1fr}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"rangesWithTime":"B1KR9G__rangesWithTime","ranges":"B1KR9G__ranges"};
